function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.375 6.48705C2.375 9.58254 4.90767 12.1152 8.00316 12.1152C11.0987 12.1152 13.6313 9.58254 13.6313 6.48705C13.6313 3.39156 11.0987 0.858887 8.00316 0.858887C4.90767 0.858887 2.375 3.39156 2.375 6.48705ZM12.3071 6.48705C12.3071 8.85419 10.3703 10.7909 8.00316 10.7909C5.63602 10.7909 3.69927 8.85419 3.69927 6.48705C3.69927 4.11991 5.63602 2.18316 8.00316 2.18316C10.3703 2.18316 12.3071 4.11991 12.3071 6.48705Z",
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.44745 18.1406C3.20211 16.3859 5.51959 15.4258 8.0026 15.4258C10.4856 15.4258 12.8031 16.3859 14.5578 18.1406L15.5013 17.1971C13.4983 15.2106 10.8332 14.1016 8.0026 14.1016C5.17197 14.1016 2.50687 15.2106 0.503906 17.1971L1.44745 18.1406Z",
  fill: "#D9D9D9"
});

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.2c16deef.svg";
export { ForwardRef as ReactComponent };